import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from 'components/Button'

interface props {
  setSteps: () => void
  onClose: () => void
  onDownload?: () => void
  type: string
}

export const DownloadTemplate = (props: props): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { setSteps, onClose, onDownload, type } = props

  const { t } = useTranslation(['onboarding', 'common'])
  const base = 'con-modal-download'

  const onDisplayTitle = (type: string) => {
    switch (type) {
      case 'company':
        return t(`onboarding:title.upload.company.template`)
      case 'branch':
        return t(`onboarding:title.upload.branch.template`)
      case 'product':
        return t(`onboarding:title.upload.product.template`)
      case 'sku':
        return t(`onboarding:title.upload.sku.template`)
    }
  }

  return (
    <div className={`${base}`}>
      <h1 className={`${base}__title`}>{onDisplayTitle(type)}</h1>
      <span className={`${base}__description`}>
        {t('common:description.upload.template')}
      </span>
      <div className={`${base}__button-download`}>
        <Button variants='outline' onClick={onDownload}>
          {t('common:download.button')}
        </Button>
      </div>

      <span className={`${base}__procedure`}>
        {t('common:procedure.upload.template')}
        <br></br>
        {t('common:description.procedure.1')}
        <br></br>
        {t('common:description.procedure.2')}
        <br></br>
        {t('common:description.procedure.3')}
        <br></br>
        {/* {t('common:description.email')}
        <u className={`${base}__email`}>admin@fixtab.app</u>
        <br></br> */}
        {t('common:description.procedure.4')}
        <br></br>
        {t('common:description.procedure.5')}
        <br></br>
      </span>
      <div className={`${base}__button-group`}>
        <Button variants='secondary' onClick={onClose}>
          {t('common:wantCancel.label')}
        </Button>
        {/* <Button onClick={setSteps}>{t('common:insert.info.button')}</Button> */}
      </div>
    </div>
  )
}
